import type { CSSProperties } from 'react';

import classNames from 'classnames';

import styles from './ChevronCircle.module.css';

import { ChevronAccordion } from './ChevronAccordion';

export type ChevronCircleVariant = 'outline' | 'filled';

export interface ChevronCircleProps {
  /** Direction the chevron points. */
  orientation?: 'up' | 'down' | 'left' | 'right';
  /** Visual style of the circular container. */
  variant?: ChevronCircleVariant;
  /** Diameter of the circle in pixels. */
  size?: number;
  /** Size of the chevron icon in pixels. Defaults to 24. */
  chevronSize?: number;
}

const variantClass: Record<ChevronCircleVariant, string> = {
  outline: styles.outline,
  filled: styles.filled,
};

/**
 * A chevron icon inside a circular container. Used in the Foundation accordion
 * variant. Supports three visual styles: outline, filled, and filled with
 * ring.
 */
export function ChevronCircle({
  orientation = 'down',
  variant = 'outline',
  size = 36,
  chevronSize = 24,
}: ChevronCircleProps) {
  const containerStyle: CSSProperties = { width: size, height: size };

  return (
    <span
      className={classNames(styles.container, variantClass[variant])}
      style={containerStyle}
    >
      <ChevronAccordion orientation={orientation} size={chevronSize} />
    </span>
  );
}
